import location from './location';
import locationOutside from './locationOutside';
import roomDoor from './roomDoor'
import tree from './tree';
import equipment from './equipment';
import equipmentGroup from './equipment-group';
import equipmentGroupItem from './equipment-group-item';
import equipmentProperty from './equipment-property';
import equipmentPropertyValue from './equipment-property-value';
import point from './point';
import pointGroup from './point-group';
import pointGroupItem from './point-group-item';
import pointProperty from './point-property';
import pointPropertyValue from './point-property-value';

const DcimServer = {
    location: location,
    locationOutside: locationOutside,
    roomDoor: roomDoor,
    tree: tree,
    equipment: equipment,
    equipmentGroup: equipmentGroup,
    equipmentGroupItem: equipmentGroupItem,
    equipmentProperty: equipmentProperty,
    equipmentPropertyValue: equipmentPropertyValue,
    point: point,
    pointGroup: pointGroup,
    pointGroupItem: pointGroupItem,
    pointProperty: pointProperty,
    pointPropertyValue: pointPropertyValue,
};

export default DcimServer;
